module.exports = __webpack_public_path__ + "img/tabler-icon-chevron-right-black.60e6b96f.svg";